<template lang="pug">
    v-tabs( color="grey lighten-3" slider-color="accent" grow )
        v-tab detalle
        v-tab-item
            v-divider
            provider-information
        v-tab ordenes de compra
        v-tab-item
            v-divider
            purchase-order-list-view( no-items no-title v-bind="purchaseOrdersViewProps" )
        v-tab productos
        v-tab-item
            v-divider
            provider-products
        v-tab facturas
        v-tab-item
            v-divider
            purchase-invoice-list-view( no-items v-bind="purchaseInvoicesViewProps" )
</template>

<script>
    //
    import { mapActions } from "vuex"

    //
    import ProviderInformation from "./ProviderInformation2"
    import ProviderProducts from "./ProviderProducts"

    //
    import PurchaseOrderListView from "@/views/Purchase/PchPurchaseOrder/list"
    import PurchaseInvoiceListView from "@/views/Purchase/PchPurchaseInvoice/list"

    //
    export default {
        name: "provider-update",
        components: {
            ProviderInformation,
            ProviderProducts,
            PurchaseInvoiceListView,
            PurchaseOrderListView,
        },
        computed: {

            /**
             * 
             */
            purchaseInvoicesViewProps () {
                return {
                    tableParams: {
                        noFilter: true,
                        noRemove: true,
                        paramFilter: {
                            pch_provider_id: this.$route.params.id,
                        },
                    },
                }
            },

            /**
             * 
             */
            purchaseOrdersViewProps () {
                return {
                    tableParams: {
                        noFilter: true,
                        noRemove: true,
                        paramFilter: {
                            pch_provider_id: this.$route.params.id,
                        },
                    },
                }
            },
        },
        methods: {

            //
            ...mapActions("MenuesModule", {
                setTitleTopBar: "setTitleTopBar",
            }),
        },
        beforeMount: function() {
            this.setTitleTopBar( "Detalle del proveedor" )
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can("VIEW_DETAIL_PURCHASE_PROVIDER"))
                    ctx.$router.push("/")
            })
        },
    }
</script>